<div class="flex">
  @if (isAuth() && !excludedRoutes.includes(currentRoute())) {
    <app-auth-sidebar />
  }

  <main
    class="w-full overflow-auto"
    [ngClass]="
      isAuth() && !excludedRoutes.includes(currentRoute())
        ? 'mt-22'
        : 'mt-0 min-h-screen'
    ">
    <router-outlet />
  </main>
</div>

<p-toast [breakpoints]="toastBreakpoints()" />

<app-confirm-dialog />
